import styled from 'styled-components';

export const SubtitleCard = styled.div`
  font-size: 12px;
  font-weight: 500;
  margin-left: .25rem;
  margin-top: ${props => props.marginTop? props.marginTop : ".5rem"};
  color: ${props => props.theme.color_gray};
`;
